export function fixViewBox(
	viewBox: eXpress.math.Rect | undefined,
	/** Minimum viewbox that contains the full preview */
	fullViewBox: eXpress.math.Rect,
): eXpress.math.Rect | undefined {
	if (!viewBox) return undefined;

	let newViewBox = eXpress.math.rect(viewBox);

	// Limit horizontal zoom
	const maxZoom = 5;
	const minWidth = fullViewBox.width / maxZoom;
	if (minWidth > newViewBox.width) {
		// Grow viewBox width, but keep center
		newViewBox.left -= (minWidth - newViewBox.width) / 2;
		newViewBox.width = minWidth;
	}

	// Limit vertical zoom
	const minHeight = fullViewBox.height / maxZoom;
	if (minHeight > newViewBox.height) {
		// Grow viewBox height, but keep center
		newViewBox.top -= (minHeight - newViewBox.height) / 2;
		newViewBox.height = minHeight;
	}

	// Try to move it in view
	if (newViewBox.left < fullViewBox.left) newViewBox.left = fullViewBox.left;
	if (newViewBox.right > fullViewBox.right) newViewBox.right = fullViewBox.right; // the right setter will move the left
	if (newViewBox.top < fullViewBox.top) newViewBox.top = fullViewBox.top;
	if (newViewBox.bottom > fullViewBox.bottom) newViewBox.bottom = fullViewBox.bottom; // the bottom setter will move the top

	// Clip what is larger than fullViewBox
	newViewBox = fullViewBox.intersect(newViewBox);

	return newViewBox;
}
